import { render, staticRenderFns } from "./SkeletonGoods.vue?vue&type=template&id=306c26c5&"
import script from "./SkeletonGoods.vue?vue&type=script&lang=js&"
export * from "./SkeletonGoods.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonGoods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports